import styled from 'styled-components'

import colors from './colors'

const Quiz = styled.div`
  background: ${colors.blue};
  padding: .75rem 1rem .5rem;
  border-radius: .5rem;
  margin: 0 0 2rem;
  box-shadow: 0 20px 20px -20px #a5a5a5;
`
const QuizQuestion = styled.div`
  color: ${colors.white};
  margin: 0 0 .5rem;
`
const QuizAnswers = styled.div`
`
const QuizAnswer = styled.div`
  display: inline-block;
  margin: 0 .5rem .5rem 0;
  background: white;
  font-size: 13px;
  color: ${colors.blue};
  padding: .33rem .5rem;
  cursor: pointer;
  opacity: .95;
  font-weight: 500;
  border-radius: 4px;
  user-select: none;

  &:hover {
    opacity: 1;
  }
`

export {
  Quiz,
  QuizQuestion,
  QuizAnswers,
  QuizAnswer,
}



// WEBPACK FOOTER //
// ./src/styles/quiz.js